import { Chip, Grid, Stack, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { textLabels } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import ActionsListWidget from '../../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allEntHorDiasAction,
  deleteEntHorDiasAction,
  setActivoEntHorDiasAction,
} from '../EntHorDiasAction';
import { PARAMS_ENTHOR_DIAS } from '../EntHorDiasReducer';

const ListadoEntHorDias = ({ isDelete = false, setIsDelete = () => {} }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entHorDiasStore = Redux.useSelector((state) => state.entHorDias);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...entHorDiasStore.params,
        idEntHorarioClase: entHorariosClasesStore.activo.id,
      };
      dispatch({ type: PARAMS_ENTHOR_DIAS, payload });
      if (entHorDiasStore.all && entHorDiasStore.all.length === 0) {
        allEntHorDiasAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    setIsDelete(false);
    const data = entHorDiasStore.all.find((el) => el.id === id);
    await setActivoEntHorDiasAction(dispatch, data);
    // setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteEntHorDiasAction(
      { dispatch, notify },
      entHorDiasStore.activo.id,
      entHorDiasStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.dia.name,
      label: CONST.dia.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" alignItems="center">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
                mr="10px"
              >
                {value}
              </NameComponent>
              {entHorDiasStore.activo?.id === tableMeta.rowData[0] &&
                !isDelete && (
                  <Chip
                    label="Editando"
                    size="small"
                    color="info"
                    sx={{ mr: 1 }}
                  />
                )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.num.name,
      label: CONST.num.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.abrev.name,
      label: CONST.abrev.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: CONST.estatus.name,
    //   label: CONST.estatus.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Tooltip
    //           describeChild
    //           title="Estatus del registro"
    //           placement="left"
    //         >
    //           <Chip
    //             label={value.nombre}
    //             size="small"
    //             color={value.id === 1 ? 'success' : 'error'}
    //           />
    //         </Tooltip>
    //       );
    //     },
    //   },
    // },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  setIsDelete(true);
                  const data = entHorDiasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoEntHorDiasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    reponsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container sx={{ mt: 1 }}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={entHorDiasStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={entHorDiasStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {entHorDiasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{entHorDiasStore.activo.dia}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoEntHorDias;
